export default "__VITE_ASSET__BWu4boOG__"